import React, { FC, ReactNode, useContext } from "react";
import { IconButton } from "@material-ui/core";
import Typography, { TypographyProps } from "@material-ui/core/Typography";
import { makeStyles, Theme, createStyles } from "@material-ui/core/styles";
import { Remove as CollapseIcon } from "@material-ui/icons";
import { VisibilityContext } from "../../context";
import { FILTERS } from "../../constants";
import { get } from "../../functions";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      display: "flex",
      flexDirection: "row",
      justifyContent: "space-between",
      alignItems: "center",
      color: theme.palette.primary.dark,
    },
    header: {
      display: "flex",
      flexDirection: "row",
    },
    title: {
      alignSelf: "baseline",
    },
  })
);

interface HeaderProps {
  icon?: ReactNode;
  title: string;
  variant: TypographyProps["variant"];
  isCollapsible?: boolean;
}

const Header: FC<HeaderProps> = ({ icon, title, variant, isCollapsible = false }) => {
  const classes = useStyles();
  let key;

  if (isCollapsible) {
    key = get.keyByValue(FILTERS.MENU_SECTION_TITLES, title);
  }

  const [visibilityContext, setVisibilityContext] = useContext(VisibilityContext);

  const handleClick = () => {
    setVisibilityContext({
      ...visibilityContext,
      [key]: !visibilityContext[key],
    });
  };

  return (
    <div className={classes.container}>
      <div className={classes.header}>
        {icon}
        <Typography variant={variant} className={classes.title}>
          {title}
        </Typography>
      </div>
      {isCollapsible && (
        <IconButton size="small" onClick={() => handleClick()}>
          <CollapseIcon />
        </IconButton>
      )}
    </div>
  );
};

export default Header;
